import { definePolicy, listQuerySchema } from '@britania/teams-kit-core';
import { reminderRecipientSchema } from '#src/approval-reminders/reminders.contract.js';
const text = {
    type: 'string',
    wildcards: true,
    caseInsensitive: true,
};
/**
 * O que `GET /api/approval-reminders/recipients` deixa filtrar, ordenar e
 * pedir. As contagens por papel são calculadas depois e não entram no filtro.
 */
export const reminderRecipientsPolicy = definePolicy({
    fields: {
        email: { ...text, sortable: true },
        name: text,
    },
    defaultSort: [{ field: 'email', direction: 'asc' }],
    selectable: reminderRecipientSchema.keyof().options,
});
export const reminderRecipientsQuerySchema = listQuerySchema(reminderRecipientsPolicy);
//# sourceMappingURL=reminder-recipients.policy.js.map